import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoanAgreementComponent } from './loan-agreement/loan-agreement.component';
import { DownPaymentComponent } from './down-payment/down-payment.component';
import { AuthGuardService } from '../auth-guard.service';
import { AppGuardService } from './app-guard.service';
import { DownPaymentFailComponent } from './down-payment-fail/down-payment-fail.component';
import { JuspayComponent } from './juspay/juspay.component';
import { CounterOfferComponent } from './counter-offer/counter-offer.component';
import { GenericErrorComponent } from '../info-pages/generic-error/generic-error.component';
import { LoginGuardService } from 'app/login-guard.service';

const routes: Routes = [
  {
    path: 'agreement',
    component: LoanAgreementComponent,
    canActivate: [AuthGuardService, AppGuardService]
  }, {
    path: 'downpayment',
    component: DownPaymentComponent,
    canActivate: [AuthGuardService, AppGuardService]
  },
  {
    path: 'payment-status/:state',
    component: DownPaymentFailComponent
  },
  {
    path: 'payment-status',
    component: DownPaymentFailComponent
  },
  {
    path: 'payment',
    component: JuspayComponent,
    canActivate: [AuthGuardService, AppGuardService]
  },
  {
    path: 'counter-offer',
    component: CounterOfferComponent,
    canActivate: [AuthGuardService, AppGuardService]
  },
  {
    path: 'counter-application',
    component: CounterOfferComponent,
    canActivate: [AuthGuardService, AppGuardService]
  },
  {
    path: 'error',
    component: GenericErrorComponent,
    canActivate: [LoginGuardService]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ApplicationRoutingModule { }
